'use client';

import { ThemeProvider } from 'next-themes';
import { ReactNode, Suspense } from 'react';
import { PostHogProvider } from './analytics/posthog-provider';
import Loader from './loader';

export function Providers({ children }: { children: ReactNode }) {
	return (
		<Suspense fallback={<Loader />}>
			<PostHogProvider>
				<ThemeProvider
					attribute="class"
					defaultTheme="system"
					enableSystem
					disableTransitionOnChange
				>
					{children}
				</ThemeProvider>
			</PostHogProvider>
		</Suspense>
	);
}
